import {axiosInstanceWithToken} from "../instances/axiosInstance";
import {useTranslation} from "i18nano";
import {useNotification} from "../stores/notificationStore";
import {isMobileOrTablet} from "../helpers/deviceHelper";

export const useDocumentViewer = () => {
    const t = useTranslation();
    const notification = useNotification();

    const viewDocument = async (id: number) => {
        try {
            const response = await axiosInstanceWithToken.get(`attachment/${id}/download`);
            if (response.data.success) {
                const downloadUrl = response.data.data.downloadUrl;

                if (!isMobileOrTablet()) {
                    window.open(downloadUrl, '_blank');
                } else {
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = "true";
                    link.click();
                }
            }
        } catch (error: any) {
            const status = error.response?.status;
            const message = (status === 401 || status === 403)
                ? t("You don't have access to this file")
                : t("The request failed");
            notification.open(message, 'error');
        }
    };

    return {viewDocument};
};